/**
 * Convert HTMLCanvasElement to Blob object that can be sent and used as File blob.
 * @param {HTMLCanvasElement} canvasImage HTMLCanvasElement to be converted to Blob.
 * @param {string} [type] A string indicating the image format. The default type is `image/png`.
 * @param {Number} [quality] A Number between `0` and `1` indicating the image quality to be used when creating images using file formats that support lossy compression (such as image/jpeg or image/webp).
 * @returns {Promise} Promise object which resolves with the Blob when successful.
 */
export const canvasImageToBlob = (canvasImage, type = 'image/png', quality = 1) =>
  new Promise((resolve, reject) => {
    const callbackFunc = (blob) => {
      if (blob) {
        resolve(blob)
      } else {
        reject()
      }
    }
    canvasImage.toBlob(callbackFunc, type, quality)
  })
